import { useState } from 'react';
import { useConnection, useDisconnect, useSwitchChain } from 'wagmi';
import { CHAIN } from '../../config/wagmi.ts';
import { useI18n } from '../../i18n/index.tsx';
import { shortAddr } from '../../lib/format.ts';
import { Button } from '../ui/primitives.tsx';
import { useConnectModal } from './ConnectModal.tsx';

export function NetworkChip() {
  const { t } = useI18n();
  const { chainId, isConnected } = useConnection();
  const { switchChain } = useSwitchChain();
  const wrong = isConnected && chainId !== CHAIN.id;
  if (wrong) {
    return (
      <button type="button" className="chip bad network" onClick={() => switchChain({ chainId: CHAIN.id })}>
        <span className="dot" />
        {t('network.wrong')}
      </button>
    );
  }
  return (
    <span className="chip network">
      <span className="dot" />
      {CHAIN.name}
    </span>
  );
}

export function WalletButton() {
  const { t } = useI18n();
  const { address, isConnected } = useConnection();
  const { disconnect } = useDisconnect();
  const open = useConnectModal();
  const [menu, setMenu] = useState(false);
  const [copied, setCopied] = useState(false);
  if (!isConnected || !address) {
    return (
      <Button size="sm" onClick={open}>
        {t('wallet.connect')}
      </Button>
    );
  }
  return (
    <div style={{ position: 'relative' }}>
      <button type="button" className="chip" onClick={() => setMenu((m) => !m)} aria-haspopup="menu" aria-expanded={menu} data-testid="wallet-chip">
        <span className="dot" />
        <span className="num">{shortAddr(address)}</span>
      </button>
      {menu ? (
        <div className="card" role="menu" style={{ position: 'absolute', right: 0, top: 44, padding: 8, display: 'flex', flexDirection: 'column', gap: 6, minWidth: 180, zIndex: 30 }}>
          <Button
            size="sm"
            variant="ghost"
            onClick={async () => {
              await navigator.clipboard?.writeText(address).catch(() => undefined);
              setCopied(true);
              setTimeout(() => setCopied(false), 1500);
            }}
          >
            {copied ? t('wallet.copied') : t('wallet.copy')}
          </Button>
          <Button
            size="sm"
            variant="ghost"
            onClick={() => {
              disconnect();
              setMenu(false);
            }}
          >
            {t('wallet.disconnect')}
          </Button>
        </div>
      ) : null}
    </div>
  );
}
